export default __webpack_public_path__ + "static/Heap-9494c5ae6d09201be3bee4e94c1e9320.png";